<script setup lang="ts">
// Slider config
const sliderConfig = {
    breakpoints: {
        0: {
            slidesPerView: 1.2
        },
        540: {
            slidesPerView: 2
        },
        768: {
            slidesPerView: 3
        },
        1024: {
            slidesPerView: 4
        }
    }
}
</script>

<template>
    <swiper-container
        :space-between="15"
        :pagination="{ clickable: true }"
        :breakpoints="sliderConfig.breakpoints"
    >
        <slot />
    </swiper-container>
</template>

<style lang="scss" scoped>
@import '../../sass/abstracts/_mixins.scss';
.swiper-horizontal {
    padding-bottom: 3rem;
}

@include media-breakpoint-down(sm) {
    :slotted(.swiper-slide-next),
    :slotted(.swiper-slide-prev) {
        transition: opacity 0.3s ease;
        opacity: 0.5;
    }
}
</style>
